// Event (role-slot) constants — Kolv v2 Phase 4.
export const EVENT_CATEGORIES = {
  culture_art: { lv: 'Kultūra un māksla', en: 'Culture & Art', ru: 'Культура и искусство' },
  music: { lv: 'Mūzika', en: 'Music', ru: 'Музыка' },
  sports_active: { lv: 'Sports un aktivitātes', en: 'Sports & Activities', ru: 'Спорт' },
  family: { lv: 'Ģimene', en: 'Family', ru: 'Семья' },
  food_drink: { lv: 'Ēdiens un dzērieni', en: 'Food & Drink', ru: 'Еда и напитки' },
  business_networking: { lv: 'Bizness un tīklošanās', en: 'Business & Networking', ru: 'Бизнес' },
  nightlife: { lv: 'Naktsdzīve', en: 'Nightlife', ru: 'Ночная жизнь' },
  charity: { lv: 'Labdarība', en: 'Charity', ru: 'Благотворительность' },
  wedding: { lv: 'Kāzas', en: 'Wedding', ru: 'Свадьба' },
  other: { lv: 'Cits', en: 'Other', ru: 'Другое' },
};

export const EVENT_STATUS = {
  open: { lv: 'Atvērts', en: 'Open', ru: 'Открыт', color: 'bg-[#4A6B53]' },
  completed: { lv: 'Pabeigts', en: 'Completed', ru: 'Завершён', color: 'bg-[#5C5C5C]' },
  cancelled: { lv: 'Atcelts', en: 'Cancelled', ru: 'Отменён', color: 'bg-red-500' },
};
